<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>问卷调查 / {{ id ? '编辑' : '新增' }}</span>
         <div class="action-btns">
            <el-button v-if="formData.status === 2 || !id" type="primary" @click="clickSave">保存</el-button>
            <el-button @click="$router.go(-1)">返回</el-button>
         </div>
      </div>

      <div class="form-wrapper">
         <el-form class="advert-popup-form" label-width="100px" label-position="left" :model="formData" :rules="formRules" ref="formRef">
            <el-form-item label="标题" prop="title">
               <el-input 
                  placeholder="请输入" 
                  v-model="formData.title" 
                  maxlength="10"
                  show-word-limit
                  :disabled="formData.status === 1">
               </el-input>
               <div class="tip-text">限制为10个字</div>
            </el-form-item>

            <el-form-item label="H5链接" prop="h5Url">
               <el-input 
                  placeholder="请输入" 
                  v-model="formData.h5Url"
                  :disabled="formData.status === 1">
               </el-input>
            </el-form-item>

            <el-form-item label="是否弹窗提示" required class="popup-prompt-form-item">
               <div class="popup-prompt-row">
                  <el-radio-group v-model="formData.isPopup" :disabled="formData.status === 1">
                     <el-radio :label="0">否</el-radio>
                     <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                  <el-input
                     v-if="formData.isPopup === 1"
                     v-model="formData.popupContent"
                     maxlength="20"
                     placeholder="请填写弹窗内容，最多20个字"
                     :disabled="formData.status === 1"
                     class="popup-prompt-input"
                  />
                  <div class="popup-prompt-example">
                     <span class="popup-prompt-example-label">示例</span>
                     <img :src="popupPromptExampleImg" alt="弹窗示例" />
                  </div>
               </div>
            </el-form-item>

            <el-form-item label="奖励" prop="rewardType">
               <el-select 
                  placeholder="请选择奖励类型" 
                  v-model="formData.rewardType" 
                  style="width: 100%"
                  :disabled="formData.status === 1">
                  <el-option 
                     v-for="item in rewardTypeOptions" 
                     :key="item.id" 
                     :label="item.name" 
                     :value="item.id">
                  </el-option>
               </el-select>
            </el-form-item>

            <el-form-item label="宣传图片" prop="coverImage">
               <UploadImage 
                  v-if="formData.status !== 1"
                  actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=1" 
                  tips="支持jpg、png，不超过10MB内"
                  :urls="formData.coverImage" 
                  @onUrls="imageUploaded">
               </UploadImage>
               <div v-else-if="formData.coverImage" class="image-preview">
                  <img :src="formData.coverImage" alt="宣传图片">
               </div>
               <span v-else>-</span>
            </el-form-item>

            <el-form-item label="日期选择" prop="dateRange">
               <el-date-picker
                  v-model="formData.dateRange"
                  type="daterange"
                  range-separator="—"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  :disabled="formData.status === 1">
               </el-date-picker>
            </el-form-item>

            <el-form-item label="学校" prop="scopeType" required>
               <div class="school-section">
                  <div class="school-scope-row">
                     <span class="label-text">涉及院系：</span>
                     <el-radio-group v-model="formData.scopeType" :disabled="formData.status === 1">
                        <el-radio :label="1">全部</el-radio>
                        <el-radio :label="2">部分</el-radio>
                     </el-radio-group>
                  </div>

                  <div class="campus-zone-section">
                     <div class="section-label">{{ formData.scopeType === 1 ? '屏蔽校区' : '应用校区' }}</div>
                     <div v-if="formData.status !== 1" style="display: flex; align-items: center; margin-bottom: 8px">
                        <el-select 
                           v-model="selectedCampusUnid" 
                           placeholder="请选择校区" 
                           filterable 
                           style="flex: 1; margin-right: 8px">
                           <el-option 
                              v-for="item in campusZoneList" 
                              :key="item.value" 
                              :label="item.label" 
                              :value="item.value" />
                        </el-select>
                        <el-button @click="handleAddCampus">添加</el-button>
                     </div>
                     <div class="campus-list-wrap">
                        <div v-for="item in formData.campusList" :key="item.value" class="campus-item">
                           <span>{{ item.label }}</span>
                           <el-button 
                              v-if="formData.status !== 1"
                              type="text" 
                              icon="el-icon-circle-close" 
                              @click="handleDeleteCampus(item.value)">
                           </el-button>
                        </div>
                     </div>
                     <div class="campus-footer">
                        共计{{ formData.campusList.length }}所学校
                     </div>
                  </div>
               </div>
            </el-form-item>

            <el-form-item v-if="id" label="创建时间">
               <span>{{ formatDateTime(formData.createTime) || '-' }}</span>
            </el-form-item>

            <el-form-item v-if="id" label="更新时间">
               <span>{{ formatDateTime(formData.updateTime) || '-' }}</span>
            </el-form-item>
         </el-form>
      </div>
   </div>
</template>

<script>
import UploadImage from "../../UploadItems/UploadImage.vue";
import popupPromptExampleImg from "../../../assets/popup-prompt-example.png";

export default {
   components: {
      UploadImage
   },

   data() {
      return {
         loading: false,
         id: "",
         popupPromptExampleImg,
         campusZoneList: [], // 所有校区/院系列表
         selectedCampusUnid: null, // 当前选中的院系
         rewardTypeOptions: [], // 奖励类型选项
         formData: {
            title: "",
            h5Url: "",
            isPopup: 0,
            popupContent: "",
            rewardType: "", // 奖励类型
            coverImage: "",
            dateRange: [],
            scopeType: 1, // 涉及院系：1-全部，2-部分
            campusList: [], // 已选择的院系列表
            status: 2, // 状态：1-已发布，2-撤销发布
            createTime: "",
            updateTime: "",
         },
         formRules: {
            title: { 
               required: true, 
               message: "请输入标题", 
               trigger: "blur" 
            },
            h5Url: { 
               required: true, 
               message: "请输入H5链接", 
               trigger: "blur" 
            },
            rewardType: { 
               type: "number", 
               required: true, 
               message: "请选择奖励类型", 
               trigger: "change" 
            },
            coverImage: { 
               required: true, 
               message: "请上传宣传图片", 
               trigger: "change" 
            },
            dateRange: { 
               type: "array", 
               required: true, 
               message: "请选择日期范围", 
               trigger: "change" 
            },
            scopeType: { 
               type: 'number', 
               required: true, 
               message: "请选择涉及院系", 
               trigger: "change" 
            },
         },
      }
   },

   mounted() {
      const queryInfo = this.$route.query;
      
      // 加载奖励类型列表
      this.getRewardTypeList();
      
      if (queryInfo.id) {
         this.id = queryInfo.id;
         this.apiGetCampusZones().then(() => {
            this.queryDetailInfo();
         });
      } else {
         this.apiGetCampusZones();
      }
   },

   methods: {
      // 查询详情信息
      queryDetailInfo() {
         this.loading = true;
         this.$http({
            url: this.$util.domain + "/adminapi/user-research/detail",
            method: "GET",
            params: { id: this.id }
         }).then((res) => {
            if (res.body.data && JSON.stringify(res.body.data) !== "{}") {
               const data = res.body.data;
               
               // 处理日期格式 - 时间戳转换为日期字符串
               let startDate = '';
               let endDate = '';
               
               if (data.startTime) {
                  // 如果是时间戳（数字）
                  if (typeof data.startTime === 'number') {
                     const d = new Date(data.startTime);
                     startDate = this.formatDate(d);
                  } else if (typeof data.startTime === 'string') {
                     // 如果是字符串，去掉时间部分
                     startDate = data.startTime.split(' ')[0];
                  }
               }
               
               if (data.endTime) {
                  // 如果是时间戳（数字）
                  if (typeof data.endTime === 'number') {
                     const d = new Date(data.endTime);
                     endDate = this.formatDate(d);
                  } else if (typeof data.endTime === 'string') {
                     // 如果是字符串，去掉时间部分
                     endDate = data.endTime.split(' ')[0];
                  }
               }
               
               this.formData = {
                  title: data.name,
                  h5Url: data.h5Url,
                  isPopup: data.isPopup != null ? data.isPopup * 1 : 0,
                  popupContent: data.popupContent || "",
                  rewardType: data.rewardId,
                  coverImage: data.imgUrl,
                  dateRange: startDate && endDate ? [startDate, endDate] : [],
                  scopeType: data.scopeType || 1,
                  campusList: [],
                  status: data.status === 0 ? 1 : 2, // API: 0-已发布, 1-已撤销; 前端: 1-已发布，2-撤销发布
                  createTime: data.createTime || '',
                  updateTime: data.updateTime || '',
               }
               
               // 如果状态为已发布，提示不能编辑
               if (this.formData.status === 1) {
                  this.$message.warning('已发布的问卷不能编辑，请先撤销发布');
               }
               
               // 转换 unidList 为 campusList
               if (data.unidList && Array.isArray(data.unidList) && data.unidList.length > 0) {
                  this.formData.campusList = data.unidList.map(unid => {
                     const campus = this.campusZoneList.find(item => item.value === unid);
                     if (campus) {
                        return campus;
                     } else {
                        console.warn(`未找到院系 ID: ${unid}`);
                        return { label: `院系${unid}`, value: unid };
                     }
                  });
               }
            }
         }).catch((error) => {
            this.$util.errorMsg('获取详情信息失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 格式化日期为 yyyy-MM-dd 格式
      formatDate(date) {
         if (!date) return '';
         // 如果是字符串且已经是正确格式，直接返回
         if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
            return date;
         }
         // 如果是 Date 对象或其他格式，转换为标准格式
         const d = new Date(date);
         const year = d.getFullYear();
         const month = String(d.getMonth() + 1).padStart(2, '0');
         const day = String(d.getDate()).padStart(2, '0');
         return `${year}-${month}-${day}`;
      },

      // 格式化日期时间为 yyyy-MM-dd HH:mm:ss 格式
      formatDateTime(timestamp) {
         if (!timestamp) return '';
         const d = new Date(timestamp);
         const year = d.getFullYear();
         const month = String(d.getMonth() + 1).padStart(2, '0');
         const day = String(d.getDate()).padStart(2, '0');
         const hours = String(d.getHours()).padStart(2, '0');
         const minutes = String(d.getMinutes()).padStart(2, '0');
         const seconds = String(d.getSeconds()).padStart(2, '0');
         return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },

      // 发送信息
      sendInfo() {
         this.loading = true;
         
         // 转换 campusList 为 unidList
         const unidList = this.formData.campusList.map(item => item.value);
         
         // 格式化日期并转换为时间戳
         const startDate = this.formatDate(this.formData.dateRange[0]);
         const endDate = this.formatDate(this.formData.dateRange[1]);
         
         // 转换为时间戳（毫秒）
         const startTimestamp = new Date(startDate + ' 00:00:00').getTime();
         const endTimestamp = new Date(endDate + ' 23:59:59').getTime();
         
         // 构建提交参数（根据API文档字段）
         const params = {
            name: this.formData.title,
            h5Url: this.formData.h5Url,
            isPopup: this.formData.isPopup * 1,
            popupContent: this.formData.isPopup === 1 ? this.formData.popupContent.trim() : "",
            rewardId: this.formData.rewardType,
            imgUrl: this.formData.coverImage,
            startTime: startTimestamp,
            endTime: endTimestamp,
            scopeType: this.formData.scopeType,
            unidList: unidList,
         };
         
         // 编辑时需要传ID和needUpdateRelation
         if (this.id) {
            params.id = parseInt(this.id);
            params.needUpdateRelation = true; // 编辑时总是更新关系表
         }
         
         // 根据是否有ID选择接口
         const apiUrl = this.id 
            ? this.$util.domain + "/adminapi/user-research/edit"
            : this.$util.domain + "/adminapi/user-research/add";
         
         this.$http({
            url: apiUrl,
            method: "POST",
            dataType: "json",
            body: JSON.stringify(params)
         }).then((res) => {
            if (res.body.error === 10000) {
               this.$message.success(this.id ? '编辑成功' : '新增成功');
               // 使用 push 跳转，确保列表页会刷新
               this.$router.push({
                  path: '/yunying/activity/questionnaireManage'
               });
            } else {
               this.$util.errorMsg(res.body.message);
            }
         }).catch((err) => {
            this.$util.errorMsg(err.message || '操作失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 获取奖励类型列表
      getRewardTypeList() {
         this.$http({
            url: this.$util.domain + '/adminapi/privilegeConfig/list',
            method: 'GET',
            params: { 
               status: 1, // 只获取已发布的
               pageNum: 1,
               pageSize: 100
            }
         }).then((res) => {
            if (res.data.data && res.data.data.models) {
               this.rewardTypeOptions = res.data.data.models.map(item => ({
                  id: item.id,
                  name: item.name
               }));
            }
         }).catch((err) => {
            console.error('获取奖励类型失败', err);
         });
      },

      // 获取奖励类型名称
      getRewardTypeName(type) {
         const rewardTypeItem = this.rewardTypeOptions.find(r => r.id === type);
         return rewardTypeItem ? rewardTypeItem.name : '-';
      },

      // 图片上传成功
      imageUploaded(img) {
         this.formData.coverImage = img;
      },

      // 点击保存
      clickSave() {
         this.$refs.formRef.validate((valid) => {
            if (valid) {
               if (this.formData.isPopup === 1 && !this.formData.popupContent.trim()) {
                  this.$util.errorMsg("请填写弹窗内容");
                  return;
               }
               this.sendInfo();
            }
         });
      },

      // 获取所有校区/院系
      apiGetCampusZones() {
         return this.$http({
            url: this.$util.domain + "/adminapi/v1/basicTools/allCampusZones",
            method: "GET",
         }).then((res) => {
            if (res.body.data && res.body.data.length) {
               this.campusZoneList = res.body.data.map((item) => ({
                  label: item.name,
                  value: item.unid,
               }));
            } else {
               this.campusZoneList = [];
            }
            return Promise.resolve();
         }).catch((error) => {
            this.campusZoneList = [];
            this.$util.errorMsg('获取院系列表失败');
            return Promise.reject(error);
         });
      },

      // 添加院系
      handleAddCampus() {
         if (!this.selectedCampusUnid) {
            this.$util.errorMsg('请选择院系');
            return;
         }
         // 检查是否已经添加
         const exists = this.formData.campusList.find((item) => {
            return item.value === this.selectedCampusUnid;
         });
         if (exists) {
            this.$util.errorMsg('该院系已添加');
            this.selectedCampusUnid = null;
            return;
         }
         // 查找院系信息
         const campus = this.campusZoneList.find((item) => {
            return item.value === this.selectedCampusUnid;
         });
         if (campus) {
            this.formData.campusList = [...this.formData.campusList, campus];
            this.selectedCampusUnid = null;
         }
      },

      // 删除院系
      handleDeleteCampus(unid) {
         const index = this.formData.campusList.map((item) => item.value).indexOf(unid);
         if (index > -1) {
            this.formData.campusList.splice(index, 1);
         }
      },

   }
}
</script>

<style scoped>
.container-wrapper {
   padding: 20px;
}

.breadcrumb-wrapper {
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 20px;
   font-size: 16px;
}

.action-btns {
   display: flex;
   gap: 10px;
}

.form-wrapper {
   background: #fff;
   padding: 20px;
   border-radius: 4px;
}

.tip-text {
   font-size: 12px;
   color: #999;
   margin-top: 4px;
}

.image-preview {
   margin-top: 10px;
}

.image-preview img {
   max-width: 400px;
   max-height: 300px;
   border-radius: 4px;
   border: 1px solid #dcdfe6;
}

.school-section {
   width: 100%;
}

.school-scope-row {
   display: flex;
   align-items: center;
   margin-bottom: 16px;
}

.school-scope-row .label-text {
   font-size: 14px;
   color: #606266;
   margin-right: 12px;
}

.campus-zone-section {
   margin-top: 8px;
}

.section-label {
   font-size: 14px;
   color: #606266;
   margin-bottom: 8px;
   font-weight: 500;
}

.campus-list-wrap {
   box-sizing: border-box;
   width: 100%;
   min-height: 120px;
   max-height: 200px;
   overflow: auto;
   padding: 10px;
   border: 1px solid #DCDFE6;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.5;
}

.campus-item {
   display: inline-flex;
   align-items: center;
   margin: 0 4px 4px;
   padding: 4px 8px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.5;
   background-color: #f5f7fa;
}

.campus-item span {
   margin-right: 4px;
}

.campus-footer {
   margin-top: 8px;
   text-align: right;
   font-size: 14px;
   color: #606266;
}
</style>




// WEBPACK FOOTER //
// questionnaireSurvey.vue?150b37a1